export const Const = {
	photodir: "/uploads/photo",
	tempdir: "/uploads/temp",
};